import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { TextField, Button, Stack, MenuItem } from "@mui/material";






const PeopleForm = () => {

    const { register, handleSubmit, watch, formState: { errors }, handleChange, control } = useForm();

    const [gender, setGender] = useState('');


    const onSubmit = (data) => {
        console.log(data);
    }

    const onChange = (e) => {
        setGender(e.target.value);
        console.log(e.target.value);
    }
    const [date_of_birth, setdate_of_birth] = useState();






    return (

        <>


            <div>

                <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off'>

                    <Stack spacing={2} >

                        <h1>People Form</h1>


                        <TextField name="first_name" label='First name' {...register("first_name")} />

                        <TextField name='last_name' label='Last name' {...register("last_name")} />

                        <TextField name='name_versions' label='Other Name Versions' multiline  {...register("name_versions")} />

                        <TextField select label='Gender' name='gender' defaultValue='' {...register('gender')}>
                            <MenuItem key={'none'} value=''>None</MenuItem>
                            <MenuItem key={'male'} value='m'>Male</MenuItem>
                            <MenuItem key={'female'} value='f'>Female</MenuItem>
                            <MenuItem key={'diverse'} value='d'>Diverse</MenuItem>
                        </TextField>

                        <label htmlFor='date_of_birth'>Date of birth:</label>
                        <input type="date" id='date_of_birth' {...register('date_of_birth', { valueAsDate: true })} />

                        <TextField name='city_of_birth' label='City of birth' {...register('city_of_birth')} />

                        <TextField name='country' label='Country' {...register('country')} />

                        <TextField name='camp_id' label='Camp Id.' {...register('camp_id')} />

                        <label htmlFor='entrance_date'>Date of entrance:</label>
                        <input type="date" id='entrance_date' {...register('entrance_date', { valueAsDate: true })} />

                        <label htmlFor='exit_date'>Date of exit:</label>
                        <input type="date" id='exit_date' {...register('exit_date', { valueAsDate: true })} />

                        <label htmlFor='labour_start_date'>Date of labour start:</label>
                        <input type="date" id='labour_start_date' {...register('labour_start_date', { valueAsDate: true })} />

                        <label htmlFor='labour_end_date'>Date of labour end:</label>
                        <input type="date" id='labour_end_date' {...register('labour_end_date', { valueAsDate: true })} />

                        <label htmlFor="notes">Notes:</label>
                        <textarea name="notes" id="notes" {...register('notes')}></textarea>

                        <label htmlFor="other_documents">Other documents</label>
                        <textarea name="other_documents" id="other_documents" {...register('other_documents')}></textarea>


                        <TextField name='link_archive' label='Link to the archive:' {...register('link_archive')} />

                        <TextField name='checked_by' label='Checked by:' {...register('checked_by')} />

                        <Button type='submit' variant="outlined">Submit</Button>
                    </Stack>
                    
                </form>
            </div>
        </>

    )
}

export default PeopleForm